module.exports = __webpack_public_path__ + "img/album.d34c48a8.png";